import { render, staticRenderFns } from "./life.vue?vue&type=template&id=0dc44ced&scoped=true"
import script from "./life.vue?vue&type=script&lang=js"
export * from "./life.vue?vue&type=script&lang=js"
import style0 from "./life.vue?vue&type=style&index=0&id=0dc44ced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc44ced",
  null
  
)

export default component.exports